class BackInStockForm extends HTMLElement {
  constructor () {
    super()
    this.btn = this.querySelector('.bis__btn')
    this.btn_spinner = this.querySelector('.loading-overlay__spinner')
    this.btn_label = this.querySelector('.bis__btn-label')
    this.input = this.querySelector('.bis__input')
    this.newsletterCheckbox = this.querySelector('.bis__newsletter-checkbox')
    this.input.addEventListener('blur', this.hideMessage.bind(this))
    this.form = this.querySelector('form')
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
    this.email_error = this.querySelector('.bis__email-error-msg')
    this.server_error = this.querySelector('.bis__server-error-msg')
    this.success_msg = this.querySelector('.bis__success-msg')
    this.success_msg_close = this.querySelector('.bis__success-close')
    this.submissions = []

    // bis popup variant selection handler
    var bis_dialog = this.closest('modal-dialog')
    var bis_popup_opener = document.querySelector(`[data-modal="#${bis_dialog?.id}"]`)
    if (bis_popup_opener) {
        // bis popup gets brought in from the form replacement
        var bis_popup = document.querySelector(bis_popup_opener?.dataset.modal)
        var bis_popup_form = bis_popup.querySelector('back-in-stock-form')
        var bis_variant_selector = bis_popup.querySelector('.product-parameters select')
        bis_variant_selector?.addEventListener('change', (event) => {
            bis_popup_form?.setAttribute('data-variant-id', event.target.value)
            bis_popup_form?.showForm()
        })
        this.success_msg_close?.addEventListener('click', (event) => {
          bis_popup?.hide()
        })
    } else {
      this.success_msg_close?.remove()
    }
  }

  validateEmail (email) {
    // eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
  }

  async onSubmitHandler (e) {
    e.preventDefault()
    const email = this.input.value
    const variant_id = this.getAttribute('data-variant-id')
    const product_id = this.getAttribute('data-product-id')
    const shop_id = this.getAttribute('data-shop-id')
    const klaviyo_id = this.getAttribute('data-klaviyo-id')
    const klaviyo_list_id = this.getAttribute('data-klaviyo-list-id')
    this.submissions = []

    if (klaviyo_id) { // klaviyo public back in stock request
      this.submissions.push({
        completed: false,
        end_point_url: `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${klaviyo_id}`,
        requestOptions: {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
          },
          body: JSON.stringify({
            "data": {
              "type": "back-in-stock-subscription",
              "attributes": {
                "profile": {
                  "data": {
                    "type": "profile",
                    "attributes": {
                      "email": `${email}`
                    }
                  }
                },
                "channels": ["EMAIL"]
              },
              "relationships": {
                "variant": {
                  "data": {
                    "type": "catalog-variant",
                    "id": `$shopify:::$default:::${variant_id}`
                  }
                }
              }
            }
          })
        }
      })
      // handler for additional klaviyo list subscription
      if(klaviyo_list_id && this.newsletterCheckbox?.checked) {
        this.submissions.push({
          completed: false,
          end_point_url: `https://a.klaviyo.com/client/subscriptions?company_id=${klaviyo_id}`,
          requestOptions: {
            method: 'POST',
            headers: {
              accept: 'application/vnd.api+json',
              revision: '2024-10-15',
              'content-type': 'application/vnd.api+json'
            },
            body: JSON.stringify({
              "data": {
                "type": "subscription",
                "attributes": {
                  "profile": {
                    "data": {
                      "type": "profile",
                      "attributes": {
                        "email": `${email}`
                      }
                    }
                  }
                },
                "relationships": {
                  "list": {
                    "data": {
                      "type": "list",
                      "id": `${klaviyo_list_id}`
                    }
                  }
                }
              }
            })
          }
        })
      }
    } else {
      this.submissions.push({
        completed: false,
        end_point_url: `/a/app/back-in-stock/query`,
        requestOptions: {
          method: 'POST',
          headers: {
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            query: `
              mutation CreateBackInStockRequest($input : NewBackInStockRequest!) {
                createBackInStockRequest(input: $input) {
                  id
                  expiresAt
                  variant {
                    id
                    product {
                      id
                      shop {
                        id
                      }
                    }
                  }
                }
              }
            `,
            variables: { 
              input: {
                userEmail: email,
                variantID: variant_id,
                productID: product_id,
                shopID: shop_id
              }
            }
          })
        }
      })
    }

    if (this.validateEmail(email)) {
      this.lockButton()
      this.submissions.forEach((submission, index) => {
        this.updateSubmissionProgress(index, false)
        this.submitForm(index, submission.end_point_url, submission.requestOptions)
      })
    } else {
      this.email_error.classList.remove('hidden')
    }
  }

  async submitForm (index, end_point_url, requestOptions) {
    const success_msg_type = this.getAttribute('data-success')
    try {
      const response = await fetch(end_point_url, requestOptions)
      if (response.ok) {
        if (success_msg_type === 'popup') {
          const dialog = e.target.closest('.bis__wrapper')
          if (dialog) {
            dialog.querySelector('dialog').showModal()
          }
          document.body.classList.add('overflow-hidden')
        } else {
          this.hideForm()
          this.success_msg.classList.remove('hidden')
          if (!this.server_error.classList.contains('hidden')) {
            this.server_error.classList.add('hidden')
          }
        }
        this.input.value = ''
      } else {
        this.server_error.classList.remove('hidden')
      }
    } catch (error) {
      this.server_error.classList.remove('hidden')
      console.error(error)
    } finally {
      this.updateSubmissionProgress(index, true)
    }
  }

  updateSubmissionProgress (index, value) {
    this.submissions[index].completed = value
    for (const submission of this.submissions) {
      if (submission.completed == false) {
        return
      }
    }
    this.unlockButton()
  }

  lockButton () {
    this.btn.disabled = true
    this.btn.classList.add('loading')
    this.btn_spinner.classList.remove('hidden')
    this.btn_label.classList.add('opacity-0')
  }

  unlockButton () {
    this.btn.classList.remove('loading')
    this.btn_spinner.classList.add('hidden')
    this.btn_label.classList.remove('opacity-0')
    this.btn.disabled = false
  }

  hideMessage () {
    this.email_error.classList.add('hidden')
    this.server_error.classList.add('hidden')
    this.success_msg.classList.add('hidden')
  }

  showForm () {
    this.hideMessage()
    this.form.classList.remove('hidden')
  }

  hideForm () {
    this.form.classList.add('hidden')
  }
}
if (!customElements.get('back-in-stock-form')) {
  customElements.define('back-in-stock-form', BackInStockForm)
}
